import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { PaginationControlsComponent } from 'ngx-pagination';
import { NgxPaginationModule } from 'ngx-pagination';
import { SharedModule } from '../shared/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { AngularSvgIconModule } from 'angular-svg-icon';

import { CreateServiceGroupComponent } from './create-service-group/create-service-group.component';
import { ListServiceGroupComponent } from './list-service-group/list-service-group.component';
import { CreateNewCustomerComponent } from './create-new-customer/create-new-customer.component';
import { ListCustomerServiceUserComponent } from './list-customer-service-user/list-customer-service-user.component';
import { MemberListByGroupComponent } from './member-list-by-group/member-list-by-group.component';
import { ViewMemberDetailsComponent } from './view-member-details/view-member-details.component';
import { UpdateNewCustomerComponent } from './update-new-customer/update-new-customer.component';

const routes: Routes = [
  { path: '', component: CreateServiceGroupComponent },
  { path: 'list-service-group', component: ListServiceGroupComponent },
  { path: 'create-new-customer', component: CreateNewCustomerComponent },
  { path: 'list-customer-service-user', component: ListCustomerServiceUserComponent },
  { path: 'member-by-group/:id', component: MemberListByGroupComponent },
  { path: 'view-member-details/:id', component: ViewMemberDetailsComponent },
  { path: 'update-new-customer/:id', component: UpdateNewCustomerComponent },
];

@NgModule({
  declarations: [
    CreateServiceGroupComponent,
    ListServiceGroupComponent,
    CreateNewCustomerComponent,
    ListCustomerServiceUserComponent,
    MemberListByGroupComponent,
    ViewMemberDetailsComponent,
    UpdateNewCustomerComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    FormsModule,
    NgxPaginationModule,
    RouterModule.forChild(routes),
    SharedModule,
    ReactiveFormsModule,
    HttpClientModule,
    AngularSvgIconModule.forRoot(),
    NgSelectModule,
  ],
  exports: [RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CustomerserviceModule { }
